module.exports = __webpack_public_path__ + "static/media/ic_proyectos_fluvial_pin_seleccionado.da159ab5.svg";